export const PrimaryErrorDiv = 
    "bg-error-50 text-error-700 py-1 px-2 rounded-sm flex mt-5 ml-4 mr-4 mb-2";